;(function() {
  const accordionTitles = document.querySelectorAll('.accordion__title')
  if (!accordionTitles) return
  for (const title of accordionTitles) {
    title.addEventListener('click', toggleAccordion)
  }
  function toggleAccordion(e) {
    const accordion = e.target.parentElement.classList.toggle('active')
  }
})()
